import React, { useEffect } from 'react'

import { doFetchLinearTeams } from 'ducks/integrations/linear'
import { Flex, Label } from 'shared/ui'
import { useDispatch } from 'react-redux'

import LinkExistingLinearIssueModal from './LinkExistingLinearIssueModal'
import LinkNewLinearIssueModal from './LinkNewLinearIssueModal'

export default function LinkLinearIssue() {
  const dispatch = useDispatch()

  useEffect(
    () => {
      dispatch(doFetchLinearTeams())
    },
    [dispatch]
  )

  return (
    <div className="LinkLinearIssue">
      <Label size="small">Link Conversation To Issue</Label>
      <Flex>
        <LinkExistingLinearIssueModal />
        <LinkNewLinearIssueModal />
      </Flex>
    </div>
  )
}
